import { ReactComponent as CloseButton } from "assets/svg/outline-cross.svg";
import { useOrchidPro } from "components/Dashboard/DoctorDashboard/contexts/orchid-pro-context";
import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./NotesPanel.module.scss";
import PreviousSessions from "./PreviousSessions";
import PsychotherapyNotes from "./PsychotherapyNotes";

interface NotesPanelProps {
  nightMode?: boolean;
  patientId: string;
  currOrchidProId: string;
  appointmentId: string;
  close: () => void;
}

const NotesPanel = ({
  nightMode,
  patientId,
  currOrchidProId,
  appointmentId,
  close,
}: NotesPanelProps) => {
  const [selectedTab, setSelectedTab] = useState<
    "previous-sessions" | "psychotherapy-notes"
  >("previous-sessions");

  const { orchidPro } = useOrchidPro();

  if (!orchidPro || orchidPro.cognito_sub !== currOrchidProId) {
    return (
      <div
        className={getClasses(
          "p-4",
          styles["container"],
          nightMode && styles["container--night-mode"],
        )}
      >
        You must be logged in to access this feature
      </div>
    );
  }

  return (
    <div
      className={getClasses(
        styles["container"],
        nightMode && styles["container--night-mode"],
      )}
    >
      <div
        className={getClasses(
          nightMode && styles["header--night-mode"],
          styles["header"],
        )}
      >
        <Tabs
          activeKey={selectedTab}
          id="prevbious-sessions-tabs"
          onSelect={(tab) => {
            if (tab === "previous-sessions" || tab === "psychotherapy-notes") {
              setSelectedTab(tab);
            } else {
              if (process.env.NODE_ENV !== "production") {
                console.warn(
                  "Unknown tab selected in PreviousSessions component:",
                  tab,
                );
              }
            }
          }}
          className={styles["tabs"]}
        >
          <Tab
            tabClassName={styles["tab"]}
            eventKey="previous-sessions"
            title="Notes"
          />
          <Tab
            tabClassName={styles["tab"]}
            eventKey="psychotherapy-notes"
            title="Psychotherapy Notes"
          />
        </Tabs>
        <CloseButton onClick={close} />
      </div>
      {selectedTab === "previous-sessions" && (
        <PreviousSessions patientId={patientId} />
      )}
      {selectedTab === "psychotherapy-notes" && (
        <PsychotherapyNotes
          patientId={patientId}
          appointmentId={appointmentId}
        />
      )}
    </div>
  );
};

export default NotesPanel;
